<template>
  <div class="container" :style="{ width: width + 'px' }">
    <div class="box-title" @click="showHide">
      <div style="display: inline-block; margin-left: 42px; font-style: italic; font-size: 14pt;">{{ title }}</div>
      <div class="arrow" :class="!show ? 'arrow-up' : 'arrow-down'" @click.stop="showHide" style="pointer-events: auto;"></div>
    </div>
    <div class="box-seperator"></div>
    <div v-show="show" class="box-content" :style="{ backgroundImage: `url(${backgroundImage})`, height: height }">
      <slot></slot>

      <i class="moving-light top-light"></i>
      <i class="moving-light bottom-light"></i>
      <i class="moving-light left-light"></i>
      <i class="moving-light right-light"></i>
    </div>
  </div>

</template>
<script>

export default {
  name: "ContentBox",
  props: [
    'title',
    'width',
    'height',
    'backgroundImage'
  ],
  data() {
    return {
      show: true
    }
  },
  methods: {
    showHide() {
      this.show = !this.show;
      console.log(this.show);
    }
  }
};
</script>
<style scoped lang="less">
@lightWidth: 2px;
@lightColor: rgb(6, 229, 245);
@animationTime: 4s;

.box-content {
  position: relative;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;

}

.container {
  width: 100%;

  margin-bottom: 15pt;
  border: 0px solid purple;

  .box-title {
    position: relative;
    width: 100%;
    height: 26px;

    color: rgba(255, 255, 255, 1);
    font-size: 12pt;
    font-family: AlibabaPuHuiTi_2_115_Black;
    font-weight: bold;
    text-align: left;
    cursor: pointer;


    .arrow {
      position: absolute;
      right: 0;
      height: 23px;
      width: 23px;
      top: 50%;
      transform: translate(0, -50%);
      cursor: pointer;
    }

    .arrow-up {
      background-image: url('../assets/img/arrow-up.png');
      background-position: center;
    }

    .arrow-down {
      background-image: url('../assets/img/arrow-down.png');
      background-position: center;
    }
  }

  .box-seperator {
    height: 10px;
    width: 100%;
    background-image: url('../assets/img/seperator.png');
    background-repeat: no-repeat;
    background-position: left;
  }

  .box-content {
    margin-top: 3.5pt;
    border: 0px solid blue;
  }
}

.moving-light {
  position: absolute;
  display: inline-block;
}

.top-light {
  width: 100%;
  height: @lightWidth;
  top: 0px;
  left: -100%;

  background-image: linear-gradient(90deg,
      transparent,
      @lightColor,
      transparent);
  animation: left-to-right @animationTime linear infinite;
}

.right-light {
  height: 100%;
  width: @lightWidth;
  right: 0px;
  top: -100%;
  background-image: linear-gradient(0deg,
      transparent,
      @lightColor,
      transparent);
  animation: top-to-bottom @animationTime linear 1s infinite;
}

.bottom-light {
  width: 100%;
  height: @lightWidth;
  bottom: 0px;
  right: -100%;
  background-image: linear-gradient(270deg,
      transparent,
      @lightColor,
      transparent);
  animation: right-to-left @animationTime linear 2s infinite;
}

.left-light {
  height: 100%;
  width: @lightWidth;
  left: 0px;
  top: 100%;
  background-image: linear-gradient(0deg,
      transparent,
      @lightColor,
      transparent);
  animation: bottom-to-top @animationTime linear 3s infinite;
}



@keyframes left-to-right {
  0% {
    left: -100%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes top-to-bottom {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}

@keyframes right-to-left {
  0% {
    right: -100%;
  }

  50%,
  100% {
    right: 100%;
  }
}

@keyframes bottom-to-top {
  0% {
    top: 100%;
  }

  50%,
  100% {
    top: -100%;
  }
}
</style>
